import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import useDialogContext from '../../../../hooks/dialog/useDialogContext';
import { IProduct } from '../../../../shared/interfaces/IProduct';
import styles from './SharePcfButton.module.css';

type SharePcfButtonProps = {
  product: IProduct;
};

const SharePcfButton = ({ product }: SharePcfButtonProps): JSX.Element => {
  const { t } = useTranslation();
  const { openDialog } = useDialogContext();

  const onClick = () => {
    openDialog('share-pcf-dialog', { product });
  };

  return (
    <div className={classNames('w-full md:w-auto flex', styles['share-pcf-button'])}>
      <Button
        onClick={onClick}
        label={t('productDetailsPage.buttons.sharePcf')}
        icon='pi pi-arrow-right'
        iconPos='right'
        type='button'
        disabled={!product?.pcf}
        className='w-full md:w-auto md:min-w-max'
        tooltipOptions={{ showOnDisabled: true, position: 'left' }}
        tooltip={
          !product?.pcf
            ? t('productDetailsPage.tabs.productDetailsTab.sharePcfButtonDisabledTooltipText')
            : undefined
        }
      />
    </div>
  );
};

export default SharePcfButton;
